module.exports = "/_next/static/images/game-2-youtube-thumb-ebcfffd8b63077bf0c66b3cadfe98ee2.jpg";